<template>
    <div class="mail-title">
        <h1 class="mail-subject">{{ subject }}</h1>
        <div class="title-actions">
            <div class="mail-actions">
                <a-tooltip title="Yanıtla">
                    <div class="action-button" @click="$emit('reply')">
                        <i class="material-icons">reply</i>
                    </div>
                </a-tooltip>

                <a-dropdown :trigger="['click']" placement="bottomRight" overlayClassName="custom-mail-dropdown">
                    <a-tooltip title="Daha Fazla">
                        <div class="action-button">
                            <i class="material-icons">more_vert</i>
                        </div>
                    </a-tooltip>
                    <template #overlay>
                        <a-menu>
                            <a-menu-item key="reply" @click="createMailTask" v-if="refVisitorId">
                                <i class="material-icons">assignment</i>
                                <span>Görev Oluştur</span>
                            </a-menu-item>
                            <a-menu-item key="ai-sentiment" @click="handleSentimentAnalysis" class="ai-menu-item">
                                <div class="ai-tool-menu-item">
                                    <i class="material-icons">psychology</i>
                                    <span>AI Duygu Analizi</span>
                                </div>
                            </a-menu-item>
                            <a-menu-item key="ai-summary" @click="handleSummarize" class="ai-menu-item">
                                <div class="ai-tool-menu-item">
                                    <i class="material-icons">summarize</i>
                                    <span>AI Özet Oluştur</span>
                                </div>
                            </a-menu-item>
                            <a-menu-item @click="$emit('reply-all')" v-if="hasMultipleRecipients">
                                <i class="material-icons">reply_all</i>
                                <span>Tümünü Yanıtla</span>
                            </a-menu-item>
                            <a-menu-item @click="$emit('forward')">
                                <i class="material-icons">forward</i>
                                <span>Yönlendir</span>
                            </a-menu-item>
                            <a-menu-divider />
                            <a-menu-divider />
                            <a-menu-item @click="$emit('delete-thread')">
                                <i class="material-icons">delete</i>
                                <span>Sil</span>
                            </a-menu-item>
                        </a-menu>
                    </template>
                </a-dropdown>
            </div>

            <a-tooltip title="İçeriği Kapat">
                <div class="action-button" @click="$emit('close')">
                    <i class="material-icons" :style="{ color: '#22272d' }">close</i>
                </div>
            </a-tooltip>
        </div>

        <MailAIAssistant
            v-if="showAIAssistant"
            :mode="aiAssistantMode"
            :autoRun="true"
            :useCloseButton="true"
            :threadMails="threadMails"
            @close="showAIAssistant = false"
        />
    </div>
</template>

<script>
import MailAIAssistant from "./MailAIAssistant.vue";
import { mapActions } from "vuex";

export default {
    name: "ThreadHeader",
    components: {
        MailAIAssistant,
    },
    props: {
        refVisitorId: {
            type: String,
            default: null,
        },
        subject: {
            type: String,
            required: true,
        },
        threadMails: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            showAIAssistant: false,
            aiAssistantMode: "sentiment",
        };
    },
    computed: {
        hasMultipleRecipients() {
            // Son mailde birden fazla alıcı var mı kontrol et
            if (!this.threadMails || this.threadMails.length === 0) return false;

            const lastMail = this.threadMails[this.threadMails.length - 1];
            if (!lastMail) return false;

            // Mail sahibinin kendisi hariç birden fazla alıcı var mı
            const allRecipients = [...(lastMail.to_list || []), ...(lastMail.cc_list || [])];
            const userEmail = this.$parent.selectedEmail?.mail || "";

            // Kullanıcı e-postası hariç tüm alıcıları filtrele
            const filteredRecipients = allRecipients.filter((email) => email !== userEmail);

            return filteredRecipients.length > 1;
        },
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
        }),
        createMailTask() {
            this.addNewWindow({
                type: "chat-create-task",
                title: this.$t("task.createTaskVisitor"),
                payload: {
                    visitorId: this.refVisitorId,
                },
            });
        },
        async handleSentimentAnalysis() {
            this.showAIAssistant = true;
            this.aiAssistantMode = "sentiment";
        },

        async handleSummarize() {
            this.showAIAssistant = true;
            this.aiAssistantMode = "summarize";
        },

        prepareThreadContent() {
            if (!this.threadMails || this.threadMails.length === 0) return "";

            // HTML içeriğini temizleme fonksiyonu
            const stripHtmlTags = (input) => {
                if (!input) return "";
                const div = document.createElement("div");
                div.innerHTML = input;
                return div.textContent || div.innerText || "";
            };

            // Threadde bulunan tüm mailleri tarihsel sırayla birleştir
            return this.threadMails
                .map((mail) => {
                    return `
                    Tarih: ${new Date(mail.created_at || mail.createdAt).toLocaleString()}
                    Kimden: ${mail.sender}
                    Kime: ${mail.to_list.join(", ")}
                    Konu: ${mail.subject}

                    ${stripHtmlTags(mail.body_html || "")}
                    ---
                `;
                })
                .join("\n");
        },

        applySummary() {
            if (this.summary) {
                this.$emit("use-summary", this.summary);
                this.showSummary = false;
                this.$message.success("Özet yanıta eklendi");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.mail-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background-color: #f9f9f9;
    border-bottom: 1px solid #eaeaea;
    position: relative;

    .mail-subject {
        margin: 0;
        font-size: 22px;
        font-weight: 600;
        color: #333;
        line-height: 1.3;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .title-actions {
        display: flex;
        align-items: center;
        gap: 16px;

        .mail-actions {
            display: flex;
            align-items: center;
            gap: 8px;
        }
    }

    // Modal Ekranı Stili
    .sentiment-results-modal,
    .summary-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        animation: fadeIn 0.2s ease;

        .modal-content {
            background-color: white;
            width: 90%;
            max-width: 650px;
            max-height: 90vh;
            border-radius: 10px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
            display: flex;
            flex-direction: column;
            animation: zoomIn 0.3s ease;

            .modal-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 16px 24px;
                border-bottom: 1px solid #eaeaea;

                h3 {
                    margin: 0;
                    font-size: 18px;
                    font-weight: 600;
                    color: #333;
                }
            }

            .modal-body {
                padding: 20px 24px;
                overflow-y: auto;
                max-height: calc(90vh - 70px);

                .sentiment-summary {
                    display: flex;
                    justify-content: center;
                    margin-bottom: 20px;

                    .sentiment-badge {
                        display: flex;
                        align-items: center;
                        padding: 12px 24px;
                        border-radius: 100px;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

                        i {
                            font-size: 24px;
                            margin-right: 8px;
                        }

                        span {
                            font-size: 18px;
                            font-weight: 600;
                        }

                        &.pozitif {
                            background-color: #ecfdf5;
                            color: #059669;
                        }

                        &.negatif {
                            background-color: #fef2f2;
                            color: #dc2626;
                        }

                        &.nötr {
                            background-color: #f3f4f6;
                            color: #4b5563;
                        }

                        &.karışık {
                            background-color: #fffbeb;
                            color: #d97706;
                        }
                    }
                }

                .result-section {
                    background-color: #f9fafb;
                    border-radius: 10px;
                    padding: 20px;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
                    border: 1px solid #e5e7eb;
                    margin-bottom: 16px;

                    h4 {
                        display: flex;
                        align-items: center;
                        margin: 0 0 16px 0;
                        font-size: 16px;
                        font-weight: 600;
                        color: #111827;

                        i {
                            font-size: 20px;
                            margin-right: 8px;
                            color: #6366f1;
                        }
                    }

                    &.emotions-section {
                        .emotions-tags {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 8px;

                            .emotion-tag {
                                background-color: #eff6ff;
                                color: #3b82f6;
                                padding: 6px 12px;
                                border-radius: 100px;
                                font-size: 14px;
                                font-weight: 500;
                            }
                        }
                    }

                    &.explanation-section {
                        p {
                            margin: 0;
                            font-size: 15px;
                            line-height: 1.6;
                            color: #4b5563;
                        }
                    }

                    &.recommendations-section {
                        .recommendations-list {
                            margin: 0;
                            padding-left: 20px;

                            li {
                                color: #4b5563;
                                margin-bottom: 8px;
                                line-height: 1.5;
                                font-size: 15px;
                            }
                        }
                    }
                }

                .summary-content {
                    background-color: #f9fafb;
                    border-radius: 10px;
                    padding: 20px;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
                    border: 1px solid #e5e7eb;
                    margin-bottom: 20px;

                    p {
                        margin: 0;
                        font-size: 15px;
                        line-height: 1.7;
                        color: #4b5563;
                        white-space: pre-line;
                    }
                }

                .summary-actions {
                    display: flex;
                    justify-content: flex-end;

                    .action-button.apply {
                        width: auto;
                        padding: 8px 16px;
                        background-color: #6366f1;
                        color: white;
                        border-radius: 6px;

                        i {
                            color: white !important;
                            margin-right: 4px;
                        }

                        span {
                            color: white;
                            font-weight: 500;
                        }

                        &:hover {
                            background-color: #4f46e5;
                        }
                    }
                }
            }
        }
    }
}

.action-button {
    width: 32px;
    height: 32px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    background-color: transparent;
    transition: background-color 0.2s;

    &.small {
        width: 28px;
        height: 28px;
    }

    &.primary-action {
        width: auto;
        padding: 0 12px;
        background-color: #22272d;
        color: white;

        i {
            color: white !important;
        }

        span {
            margin-left: 4px;
            font-size: 13px;
            color: white;
        }
    }

    &:hover {
        background-color: rgba(0, 0, 0, 0.05);

        &.primary-action {
            background-color: #333c47;
        }
    }

    span {
        margin-left: 4px;
        font-size: 13px;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes zoomIn {
    from {
        opacity: 0;
        transform: scale(0.95);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}
</style>
